import { render, staticRenderFns } from "./FoldingSandard.vue?vue&type=template&id=204527b1&scoped=true&"
import script from "./FoldingSandard.vue?vue&type=script&lang=js&"
export * from "./FoldingSandard.vue?vue&type=script&lang=js&"
import style0 from "./FoldingSandard.vue?vue&type=style&index=0&id=204527b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204527b1",
  null
  
)

export default component.exports